import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaBars, FaTimes, FaPhoneAlt } from "react-icons/fa";
import logo from "../assets/ISIN-R.png";



const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const navItems = [
    { to: "/", label: "Home" },
    // { to: "/company", label: "Projects" },
    // { to: "/partnerships", label: "Partners" },
    // { to: "/services", label: "Services" },
    // { to: "/career", label: "Careers" },
    // { to: "/about", label: "About Us" },
    //  {
    //    to: "/contact",
    //    label: "Contact Us",
    //    icon: <FaPhoneAlt className="mr-2 text-[#1e2a38]" />, // الأيقونة قبل النص
    //  },
  ];

  return (
    <div>
      {/* الشريط العلوي */}
      <div className="h-[35px]" />
      <header>
        <nav className="font-cairo fixed top-0 w-full h-[65px] bg-white/90 backdrop-blur-md shadow-md z-50 transition-all duration-500">
          <div className="flex items-center justify-between mx-auto max-w-screen-xl px-6 h-full">
            {/* اللوجو */}
            <Link to="/" className="flex items-center">
              <img
                src={logo}
                alt="Logo"
                className="h-14 w-auto object-contain"
              />
            </Link>

            {/* القائمة للـ Desktop */}
            <div className="hidden lg:flex items-center space-x-4">
              {navItems.map((item, index) => (
                <Link
                  key={index}
                  to={item.to}
                  className="text-[#1e2a38] font-medium text-base relative group no-underline transition flex items-center"
                >
                  {item.icon && item.icon}
                  {item.label}
                  <span className="absolute left-0 -bottom-0.5 w-0 h-[2px] bg-blue-900 transition-all duration-300 group-hover:w-full"></span>
                </Link>
              ))}
            </div>

            {/* زرار الموبايل */}
            <button
              className="lg:hidden text-blue-900 text-2xl focus:outline-none"
              onClick={() => setIsOpen(!isOpen)}
            >
              {isOpen ? <FaTimes /> : <FaBars />}
            </button>
          </div>

          {/* القائمة للموبايل */}
          {isOpen && (
            <div className="lg:hidden absolute top-[55px] left-0 w-full bg-white shadow-md flex flex-col items-center py-4 space-y-4">
              {navItems.map((item, index) => (
                <Link
                  key={index}
                  to={item.to}
                  className="text-[#1e2a38] font-medium text-lg hover:text-[#1e2a38] transition flex items-center"
                  onClick={() => setIsOpen(false)}
                >
                  {item.icon && item.icon}
                  {item.label}
                </Link>
              ))}
            </div>
          )}
        </nav>
      </header>
    </div>
  );
};

export default Header;
